import $ from 'jquery';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay} from 'swiper/modules';

$('.slider').each((i, elem) => {

    const swiper = new Swiper(elem, {
        modules: [Navigation, Pagination, Autoplay],
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 7000,
            pauseOnMouseEnter: false,
        },
        navigation: {
            nextEl: elem.querySelector('.swiper-arrow--next'),
            prevEl: elem.querySelector('.swiper-arrow--prev'),
        },
        pagination: {
            renderBullet: function (index, className) {
                return '<button class="' + className + '">Slide ' + (index + 1) + '</button>';
            },
            el: elem.querySelector('.swiper-controls-pagination'),
            type: 'bullets',
            bulletElement: 'button',
            clickable: true,
        },
    });
});
